import { Skeleton } from "@/components/ui/skeleton";

const VouchingSkeleton = () => {
  return (
    <section className="relative z-10 mx-auto flex max-w-4xl flex-col gap-5 px-6 py-24 sm:gap-10">
      <div className="flex flex-col gap-4">
        <div className="flex justify-start sm:justify-end">
          <div className="flex items-center gap-1.5">
            <Skeleton className="size-3.5 rounded-full" />
            <Skeleton className="h-3 w-24" />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Skeleton className="size-14 shrink-0 rounded-full sm:size-20" />

          <div className="flex w-full min-w-0 flex-col gap-2">
            <Skeleton className="h-6 w-40" />
            <Skeleton className="h-4 w-28" />
          </div>
        </div>
      </div>

      <Skeleton className="h-px w-full rounded-none" />

      <div className="flex flex-col gap-6">
        <Skeleton className="h-5 w-48" />

        <ul className="space-y-3">
          {Array.from({ length: 2 }).map((_, i) => (
            <li key={i} className="flex gap-4">
              <Skeleton className="mt-0.5 size-5 shrink-0 rounded-full" />
              <div className="flex w-full flex-col gap-2">
                <Skeleton className="h-4 w-40" />
                <Skeleton className="h-4 w-full" />
              </div>
            </li>
          ))}
        </ul>

        <div className="flex flex-col items-center gap-2">
          <Skeleton className="h-12 w-full rounded-md" />
          <Skeleton className="h-3 w-48" />
        </div>
      </div>
    </section>
  );
};

export default VouchingSkeleton;
